export type UiTheme = 'dark' | 'light' | 'system';
export type UiDensity = 'compact' | 'standard' | 'comfortable';

export type AppearancePrefs = {
  theme: UiTheme;
  density: UiDensity;
  accent: string;
  softGlow: boolean;
  animations: boolean;
  cardTransparency: boolean;
  reduceMotion: boolean;
  editorFontSize: number;
  editorLineHeight: number;
  editorTheme: string;
  showMinimap: boolean;
  highlightActiveLine: boolean;
};

export const STORAGE_PREFIX = 'sciplex_appearance_prefs_';

export const ACCENT_SWATCHES = [
  '#4cfeff',
  '#3b82f6',
  '#8b5cf6',
  '#ec4899',
  '#f97316',
  '#22c55e',
  '#eab308',
  '#ef4444',
] as const;

export const DEFAULT_APPEARANCE_PREFS: AppearancePrefs = {
  theme: 'dark',
  density: 'standard',
  accent: '#4cfeff',
  softGlow: true,
  animations: true,
  cardTransparency: true,
  reduceMotion: false,
  editorFontSize: 14,
  editorLineHeight: 1.6,
  editorTheme: 'sciplex-dark',
  showMinimap: true,
  highlightActiveLine: true,
};

export function loadAppearancePrefs(userId: number): AppearancePrefs {
  try {
    const raw = localStorage.getItem(`${STORAGE_PREFIX}${userId}`);
    if (!raw) return { ...DEFAULT_APPEARANCE_PREFS };
    const parsed = JSON.parse(raw) as Partial<AppearancePrefs>;
    return {
      ...DEFAULT_APPEARANCE_PREFS,
      ...parsed,
      accent:
        typeof parsed.accent === 'string' && ACCENT_SWATCHES.includes(parsed.accent as (typeof ACCENT_SWATCHES)[number])
          ? parsed.accent
          : DEFAULT_APPEARANCE_PREFS.accent,
      theme: parsed.theme === 'light' || parsed.theme === 'system' ? parsed.theme : 'dark',
      density: parsed.density === 'compact' || parsed.density === 'comfortable' ? parsed.density : 'standard',
    };
  } catch {
    return { ...DEFAULT_APPEARANCE_PREFS };
  }
}

export function saveAppearancePrefs(userId: number, prefs: AppearancePrefs) {
  localStorage.setItem(`${STORAGE_PREFIX}${userId}`, JSON.stringify(prefs));
}
